import { createContext, useContext } from 'react';

// Shared state of the live channels (Hauptprogramm + Digitalradios)
// { activeChannel, channelData, playChannel, channelsVersion }
export const RadioContext = createContext({
	activeChannel: 'rgw',
	channelData: {},
	playChannel: () => {},
	channelsVersion: 0,
});

export const useRadio = () => useContext(RadioContext);
